import { EventEmitter } from '@angular/core';
var AppBasicDetailsComponent = (function () {
    function AppBasicDetailsComponent() {
        /**
         * The Event emitter used to keep track of any changes to the number of
         * creditors that should be in the formData array.
         * @type {EventEmitter<number>}
         */
        this.updateCreditorCount = new EventEmitter();
    }
    /**
     * Emits the number of creditors that should actually be in the array.
     */
    AppBasicDetailsComponent.prototype.numberOfCreditorsChanged = function () {
        this.updateCreditorCount.emit(this.formData.numberOfCreditors);
    };
    AppBasicDetailsComponent.prototype.checkValue = function (value) {
        return Number(value) > 0;
    };
    return AppBasicDetailsComponent;
}());
export { AppBasicDetailsComponent };



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/basic-details/app-basic-details.component.ts.pre-build-optimizer.js